var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "class-page topic-detail-page" },
    [
      _c("class-page-header", {
        attrs: {
          details: _vm.details,
          "current-section": parseInt(_vm.sectionId),
          course: _vm.course,
          menu: _vm.menu,
          "is-class-item-page": true
        }
      }),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.forum.TITLE))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("MAIN_CONTENT.Post.forumLoadedAt", {
                date: _vm.pageLoadedDate
              })
            )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grey-border topic-box" }, [
        _c("div", { staticClass: "row" }, [
          _vm.currentTopic.POSTER_PHOTO_URL
            ? _c("img", {
                staticClass:
                  "img-responsive rounded cp-student-photo-image-circle col-xs-3 col-md-2",
                attrs: { src: _vm.currentTopic.POSTER_PHOTO_URL, alt: "Photo" }
              })
            : _c("img", {
                staticClass:
                  "img-responsive cp-student-photo-image-circle col-xs-3 col-md-2",
                attrs: {
                  src:
                    "/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png",
                  alt: "Photo"
                }
              }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-10" }, [
            _c("strong", [
              _c("p", [_vm._v(_vm._s(_vm.currentTopic.USER_NAME))]),
              _vm._v(" "),
              _c("span", {
                staticClass: "text-primary",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.currentTopic.SUBJECT !== undefined &&
                      _vm.currentTopic.SUBJECT
                      ? _vm.post.SUBJECT
                      : "" + _vm.currentTopic.TITLE
                  )
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-11" }, [
            _c("div", {
              staticClass: "topic-preview",
              domProps: {
                innerHTML: _vm._s(
                  _vm.currentTopic !== null ? _vm.currentTopic.MESSAGE : ""
                )
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row actions-topic" }, [
          _c("div", { staticClass: "col-xs-6 text-left" }, [
            _c(
              "a",
              {
                staticClass: "back-to-topics btn on-grey",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.goToTopics()
                  }
                }
              },
              [
                _c(
                  "strong",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: "chevron-left" }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("MAIN_CONTENT.Post.backToTopics")) +
                        "\n\t\t\t\t\t\t\t\t"
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-6" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-comment",
                attrs: { type: "button", "data-toggle": "modal" },
                on: { click: _vm.openNewPostModal }
              },
              [
                _c("i", {
                  staticClass: "fas fa-comment",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  "\n\t\t\t\t\t\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.Post.comment")) +
                    "\n\t\t\t\t\t\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-refresh",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.fetchTopic(true)
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fas fa-redo",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  "\n\t\t\t\t\t\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.Post.refresh")) +
                    "\n\t\t\t\t\t\t\t"
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.currentTopic !== null
        ? [
            _vm._l(_vm.displayablePosts, function(post, index) {
              return [
                _c(
                  "div",
                  {
                    key: "post-" + post.POST_ID,
                    ref: "post_" + post.POST_ID,
                    refInFor: true,
                    staticClass: "box"
                  },
                  [
                    _c("div", { staticClass: "comment-box" }, [
                      _c("div", { staticClass: "comment-header" }, [
                        _c("div", { staticClass: "date-post" }, [
                          _c("small", { attrs: { title: post.CREATED_DATE } }, [
                            _vm._v(_vm._s(_vm.humanizeDate(post.CREATED_DATE)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          post.POSTER_PHOTO_URL
                            ? _c("img", {
                                staticClass:
                                  "img-responsive rounded cp-student-photo-image-circle col-xs-3 col-md-2",
                                attrs: {
                                  src: post.POSTER_PHOTO_URL,
                                  alt: "Photo"
                                }
                              })
                            : _c("img", {
                                staticClass:
                                  "img-responsive cp-student-photo-image-circle col-xs-3 col-md-2",
                                attrs: {
                                  src:
                                    "/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png",
                                  alt: "Photo"
                                }
                              }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-10" }, [
                            _c("strong", [
                              _c("p", [_vm._v(_vm._s(post.USER_NAME))]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "text-primary",
                                domProps: {
                                  innerHTML: _vm._s(
                                    post.SUBJECT !== undefined && post.SUBJECT
                                      ? post.SUBJECT
                                      : "RE: " + _vm.currentTopic.TITLE
                                  )
                                }
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "comment-content" }, [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(post.REPLY) }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "actions" }, [
                        post.IS_DELETED_FLG !== "Y" &&
                        post.CREATED_BY === _vm.selectedStudent.STUDENT_RID
                          ? _c(
                              "a",
                              {
                                staticClass: "btn on-grey",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openEditPostModal(post)
                                  }
                                }
                              },
                              [
                                _c(
                                  "strong",
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "pen" }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("commonText.edit")) +
                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        post.IS_DELETED_FLG === "N"
                          ? _c(
                              "a",
                              {
                                staticClass: "reply-comment",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.isReplying = post.POST_ID
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-comments on-teal"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("MAIN_CONTENT.Post.reply"))
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isReplying === post.POST_ID,
                              expression: "isReplying === post.POST_ID"
                            }
                          ],
                          staticClass: "reply-box"
                        },
                        [
                          _vm.isReplying === post.POST_ID
                            ? _c("ckeditor4", {
                                attrs: {
                                  config: _vm.editorConfig,
                                  simpleImagesDialog: true,
                                  id: "reply-message"
                                },
                                model: {
                                  value: _vm.reply.REPLY,
                                  callback: function($$v) {
                                    _vm.$set(_vm.reply, "REPLY", $$v)
                                  },
                                  expression: "reply.REPLY"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                on: {
                                  click: function($event) {
                                    _vm.isReplying = -1
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("commonText.cancel")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-comment",
                                on: {
                                  click: function($event) {
                                    return _vm.postReply(post)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.commonContent.submit")
                                  )
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "replies" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.isPostRepliesOpen(post.POST_ID) &&
                                _vm.getPostsCount(post),
                              expression:
                                "!isPostRepliesOpen(post.POST_ID) && getPostsCount( post )"
                            }
                          ],
                          key: "post-replies-count-" + post.POST_ID,
                          staticClass: "show-replies",
                          on: {
                            click: function($event) {
                              return _vm.toggleOpenPostReplies(post.POST_ID)
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "long-arrow-alt-down" }
                          }),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.getPostsCount(post) > 1
                                  ? _vm.$t("MAIN_CONTENT.Post.showNReplies", {
                                      count: _vm.getPostsCount(post)
                                    })
                                  : _vm.$t("MAIN_CONTENT.Post.showOneReply")
                              ) +
                              "\n\t\t\t\t\t\t\t\t\t\t"
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isPostRepliesOpen(post.POST_ID),
                              expression: "isPostRepliesOpen(post.POST_ID)"
                            }
                          ],
                          key: "post-replies-" + post.POST_ID
                        },
                        [
                          _c("div", { staticClass: "show-replies" }, [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.toggleOpenPostReplies(
                                      post.POST_ID
                                    )
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "arrows-alt-v" }
                                }),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("MAIN_CONTENT.Post.hideReplies")
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.getPostsReplies(post), function(reply) {
                            return _c(
                              "div",
                              {
                                key: "reply-" + reply.POST_ID,
                                ref: "post_" + reply.POST_ID,
                                refInFor: true,
                                staticClass: "replies-post"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row margin-bottom-10" },
                                  [
                                    reply.POSTER_PHOTO_URL
                                      ? _c("img", {
                                          staticClass:
                                            "img-responsive rounded cp-student-photo-image-circle col-xs-3 col-md-2",
                                          attrs: {
                                            src: reply.POSTER_PHOTO_URL,
                                            alt: "Photo"
                                          }
                                        })
                                      : _c("img", {
                                          staticClass:
                                            "img-responsive cp-student-photo-image-circle col-xs-3 col-md-2",
                                          attrs: {
                                            src:
                                              "/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png",
                                            alt: "Photo"
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-10" }, [
                                      _c("div", { staticClass: "date-post" }, [
                                        _c(
                                          "small",
                                          {
                                            attrs: { title: reply.CREATED_DATE }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.humanizeDate(
                                                  reply.CREATED_DATE
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("strong", [
                                        _c("p", [
                                          _vm._v(_vm._s(reply.USER_NAME))
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "text-primary",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              reply.SUBJECT
                                                ? reply.SUBJECT
                                                : "RE: " + post.SUBJECT
                                            )
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "comment-content",
                                        domProps: {
                                          innerHTML: _vm._s(reply.REPLY)
                                        }
                                      })
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                reply.IS_DELETED_FLG !== "Y" &&
                                reply.CREATED_BY ===
                                  _vm.selectedStudent.STUDENT_RID
                                  ? _c("div", { staticClass: "actions" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "btn on-grey",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.openEditPostModal(
                                                reply,
                                                post.SUBJECT
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "strong",
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "pen" }
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("commonText.edit")
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.$t("MAIN_CONTENT.Post.newComment"),
            show: _vm.showNewPostModal,
            "dialog-size": "lg",
            name: "newPostModal"
          },
          on: {
            close: function($event) {
              _vm.showNewPostModal = false
            }
          }
        },
        [
          [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "title" } }, [
                _vm._v(_vm._s(_vm.$t("commonText.title")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.reply.SUBJECT,
                    expression: "reply.SUBJECT",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  readonly: "true",
                  id: "title",
                  placeholder: "RE: " + _vm.currentTopic.TITLE
                },
                domProps: { value: _vm.reply.SUBJECT },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.reply, "SUBJECT", $event.target.value.trim())
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group reply-area" },
              [
                _c("label", { attrs: { for: "post" } }, [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Post.comment")))
                ]),
                _vm._v(" "),
                _c("ckeditor4", {
                  attrs: {
                    config: _vm.editorConfig,
                    simpleImagesDialog: true,
                    id: "post"
                  },
                  model: {
                    value: _vm.reply.REPLY,
                    callback: function($$v) {
                      _vm.$set(_vm.reply, "REPLY", $$v)
                    },
                    expression: "reply.REPLY"
                  }
                })
              ],
              1
            )
          ],
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.showNewPostModal = false
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("commonText.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-new",
                attrs: { type: "button" },
                on: { click: _vm.addPost }
              },
              [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.submit")))]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.$t("MAIN_CONTENT.Post.editPost"),
            show: _vm.showEditPostModal,
            "dialog-size": "lg",
            name: "editPostModal"
          },
          on: { close: _vm.closeEditPostModal }
        },
        [
          [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "title" } }, [
                _vm._v(_vm._s(_vm.$t("commonText.title")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.reply.SUBJECT,
                    expression: "reply.SUBJECT",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "title", placeholder: _vm.$t("commonText.title") },
                domProps: { value: _vm.reply.SUBJECT },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.reply, "SUBJECT", $event.target.value.trim())
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "message" } }, [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.Post.comment")))
                ]),
                _vm._v(" "),
                _c("ckeditor4", {
                  attrs: {
                    config: _vm.editorConfig,
                    simpleImagesDialog: true,
                    id: "message"
                  },
                  model: {
                    value: _vm.reply.REPLY,
                    callback: function($$v) {
                      _vm.$set(_vm.reply, "REPLY", $$v)
                    },
                    expression: "reply.REPLY"
                  }
                })
              ],
              1
            )
          ],
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: { click: _vm.closeEditPostModal }
              },
              [_vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-new",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.updatePost()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("commonText.save")))]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c("class-page-footer", {
        attrs: {
          course: _vm.course,
          menu: _vm.menu,
          "current-section": parseInt(_vm.sectionId),
          "is-class-item-page": true
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }